/**
 * Footer — Branding footer with logo + tagline
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../styles/colors';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: colors.ivoryDeep,
        py: 6,
        px: 4,
        textAlign: 'center',
        borderTop: `1px solid ${colors.borderLight}`,
      }}
    >
      {/* Logo */}
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '3px' }}>
          {[20, 15, 10].map((h, i) => (
            <Box
              key={i}
              sx={{
                width: 3.5,
                height: h,
                borderRadius: 2,
                bgcolor: colors.primary,
              }}
            />
          ))}
        </Box>
        <Typography
          sx={{
            fontFamily: '"Dancing Script", cursive',
            fontSize: '2rem',
            fontWeight: 700,
            color: colors.primary,
          }}
        >
          Chutt...
        </Typography>
      </Box>

      {/* Tagline */}
      <Typography
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontStyle: 'italic',
          fontSize: '0.95rem',
          color: colors.textLight,
          mb: 2,
        }}
      >
        Reputation Intelligence
      </Typography>

      {/* Copyright */}
      <Typography
        variant="caption"
        sx={{ color: colors.textLight, fontSize: '0.75rem' }}
      >
        {new Date().getFullYear()} Chutt... — Tous droits reserves
      </Typography>
    </Box>
  );
}

export default Footer;
